import ArchiveFiltersController from '../ArchiveFiltersController';
import type { ArchiveFilterModule } from '../types';

class ProgramActivityFilter implements ArchiveFilterModule {
    private controller: ArchiveFiltersController | null = null;
    private control: HTMLInputElement | HTMLSelectElement | null = null;

    public mount(controller: ArchiveFiltersController): void {
        this.controller = controller;
        this.init();
    }

    private init(): void {
        this.control = document.querySelector<HTMLInputElement | HTMLSelectElement>('select[name="program_activity"]')
            ?? document.querySelector<HTMLInputElement | HTMLSelectElement>('[data-program-activity-select]');

        if (!this.control) {
            return;
        }

        if (!this.controller) {
            return;
        }

        this.syncValue(this.controller.getState().programActivity);
        this.syncCounts();

        this.control.addEventListener('change', () => {
            if (!this.control) {
                return;
            }

            this.controller?.setProgramActivity(this.control.value);
        });

        this.controller.onStateChange((state) => {
            this.syncValue(state.programActivity);
            this.syncCounts();
        });
    }

    private syncValue(activity: string | null): void {
        if (!this.control) {
            return;
        }

        const nextValue = activity || 'all';

        if (this.control.value !== nextValue) {
            this.control.value = nextValue;
        }
    }

    private syncCounts(): void {
        if (!this.control) {
            return;
        }

        const meta = document.querySelector<HTMLElement>('[data-program-activity-meta]');

        if (!meta) {
            return;
        }

        this.setOptionLabel(
            'active',
            this.control.dataset.labelActive ?? 'Active only',
            Number(meta.dataset.activeCount ?? 0),
        );
        this.setOptionLabel(
            'archive',
            this.control.dataset.labelArchive ?? 'Archived',
            Number(meta.dataset.archiveCount ?? 0),
        );

        this.control.dispatchEvent(new Event('change', { bubbles: true }));
    }

    private setOptionLabel(activity: 'active' | 'archive', label: string, count: number): void {
        if (!(this.control instanceof HTMLSelectElement)) {
            return;
        }

        const option = this.control.querySelector<HTMLOptionElement>(`option[value="${activity}"]`);

        if (!option) {
            return;
        }

        const normalizedCount = Number.isFinite(count) ? count : 0;

        option.text = `${label} (${normalizedCount})`;
    }
}

export default ProgramActivityFilter;